import { IBandXlsParams } from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

export interface IJSONAPIBandExportConfigCollection {
  [IDataKeys.eventsExportConfig]: any;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export interface IJSONAPIBandExportCollection {
  [IDataKeys.eventsExport]: any;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class BandExportService {
  static createEventExport = ({
    data,
  }: {
    data: IBandXlsParams;
  }): Promise<IJSONAPIBandExportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.EVENTS_EXPORT_CONFIGS,
          data,
        });

        const eventsExportConfig = Object.keys(
          (response as IJSONAPIBandExportConfigCollection).eventsExportConfig
        )[0];

        const createExportResponse = await APIService.post({
          path: API_ENDPOINTS.EVENTS_EXPORTS,
          data: {
            eventsExportConfig,
          },
        });

        const eventsExport = Object.keys(
          (createExportResponse as IJSONAPIBandExportCollection).eventsExport
        )[0];

        const checkProgress = async () => {
          const response = await APIService.get({
            path: eventsExport,
          });

          const status = (
            Object.values(response?.[IDataKeys.eventsExport])[0] as any
          )?.attributes?.export?.status;

          if (status === "completed") {
            resolve(response);
            return;
          }

          setTimeout(checkProgress, 1000);
        };

        checkProgress();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.POST_EVENTS_EXPORT_CONFIGS
        );
        reject(error);
      }
    });
}
